"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserInfo = exports.UserInfoProvider = exports.UserInfoContext = void 0;
// @ts-nocheck
const client_1 = require("@apollo/client");
const client_2 = require("@apollo/client");
const react_1 = __importStar(require("react"));
const authContext_1 = require("./authContext");
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const GET_USER_INFO = (0, client_2.gql) `
  query getUserInfo {
    me {
      roles {
        id
        name
      }
      isAdmin
      isTgoAdmin
      isUserAdmin
      isRoleAndDataAdmin
      isAnalyticsUser
      isMapServicesUser
      isFloorPlanUser
      hasAdvancedLoggingAccess
      hasDataExportTrackingAccess
      hasSystemLoggingAccess
      username
      email
      firstName
      lastName
    }
  }
`;
exports.UserInfoContext = (0, react_1.createContext)({
    roles: [],
    roleString: '',
    isAdmin: false,
    isTgoAdmin: false,
    isUserAdmin: false,
    isRoleAndDataAdmin: false,
    isSingleSignOnUser: false,
    isAnalyticsUser: false,
    isMapServicesUser: false,
    isFloorPlanUser: false,
    hasAdvancedLoggingAccess: false,
    hasDataExportTrackingAccess: false,
    hasSystemLoggingAccess: false,
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    permissions: [],
    permissionString: '',
});
const UserInfoProvider = props => {
    const { ready } = (0, authContext_1.useAuthContext)();
    const [query, results] = (0, client_1.useLazyQuery)(GET_USER_INFO, { fetchPolicy: 'no-cache' });
    // use memo since I create a new object for now to avoid rerendering
    // TODO: select the first aggregate type Asset might not exist now
    const context = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        const roles = (results && ((_b = (_a = results === null || results === void 0 ? void 0 : results.data) === null || _a === void 0 ? void 0 : _a.me) === null || _b === void 0 ? void 0 : _b.roles)) || [];
        const permissions = (0, gen5_shared_utilities_1.permissionLabel)((_c = results === null || results === void 0 ? void 0 : results.data) === null || _c === void 0 ? void 0 : _c.me);
        return {
            roles: roles,
            roleString: roles.map(role => role.name).join(','),
            isAdmin: ((_e = (_d = results === null || results === void 0 ? void 0 : results.data) === null || _d === void 0 ? void 0 : _d.me) === null || _e === void 0 ? void 0 : _e.isAdmin) || false,
            isTgoAdmin: ((_g = (_f = results === null || results === void 0 ? void 0 : results.data) === null || _f === void 0 ? void 0 : _f.me) === null || _g === void 0 ? void 0 : _g.isTgoAdmin) || false,
            isUserAdmin: ((_j = (_h = results === null || results === void 0 ? void 0 : results.data) === null || _h === void 0 ? void 0 : _h.me) === null || _j === void 0 ? void 0 : _j.isUserAdmin) || false,
            isRoleAndDataAdmin: ((_l = (_k = results === null || results === void 0 ? void 0 : results.data) === null || _k === void 0 ? void 0 : _k.me) === null || _l === void 0 ? void 0 : _l.isRoleAndDataAdmin) || false,
            isSingleSignOnUser: ((_o = (_m = results === null || results === void 0 ? void 0 : results.data) === null || _m === void 0 ? void 0 : _m.me) === null || _o === void 0 ? void 0 : _o.isSingleSignOnUser) || false,
            isAnalyticsUser: ((_q = (_p = results === null || results === void 0 ? void 0 : results.data) === null || _p === void 0 ? void 0 : _p.me) === null || _q === void 0 ? void 0 : _q.isAnalyticsUser) || false,
            isMapServicesUser: ((_s = (_r = results === null || results === void 0 ? void 0 : results.data) === null || _r === void 0 ? void 0 : _r.me) === null || _s === void 0 ? void 0 : _s.isMapServicesUser) || false,
            isFloorPlanUser: ((_u = (_t = results === null || results === void 0 ? void 0 : results.data) === null || _t === void 0 ? void 0 : _t.me) === null || _u === void 0 ? void 0 : _u.isFloorPlanUser) || false,
            hasAdvancedLoggingAccess: ((_w = (_v = results === null || results === void 0 ? void 0 : results.data) === null || _v === void 0 ? void 0 : _v.me) === null || _w === void 0 ? void 0 : _w.hasAdvancedLoggingAccess) || false,
            hasDataExportTrackingAccess: ((_y = (_x = results === null || results === void 0 ? void 0 : results.data) === null || _x === void 0 ? void 0 : _x.me) === null || _y === void 0 ? void 0 : _y.hasDataExportTrackingAccess) || false,
            hasSystemLoggingAccess: ((_0 = (_z = results === null || results === void 0 ? void 0 : results.data) === null || _z === void 0 ? void 0 : _z.me) === null || _0 === void 0 ? void 0 : _0.hasSystemLoggingAccess) || false,
            username: ((_2 = (_1 = results === null || results === void 0 ? void 0 : results.data) === null || _1 === void 0 ? void 0 : _1.me) === null || _2 === void 0 ? void 0 : _2.username) || '',
            email: ((_4 = (_3 = results === null || results === void 0 ? void 0 : results.data) === null || _3 === void 0 ? void 0 : _3.me) === null || _4 === void 0 ? void 0 : _4.email) || '',
            firstName: ((_6 = (_5 = results === null || results === void 0 ? void 0 : results.data) === null || _5 === void 0 ? void 0 : _5.me) === null || _6 === void 0 ? void 0 : _6.firstName) || '',
            lastName: ((_8 = (_7 = results === null || results === void 0 ? void 0 : results.data) === null || _7 === void 0 ? void 0 : _7.me) === null || _8 === void 0 ? void 0 : _8.lastName) || '',
            permissionString: permissions.join(','),
            permissions: permissions,
        };
    }, [results]);
    (0, react_1.useEffect)(() => {
        if (ready) {
            query();
        }
    }, [query, ready]);
    return react_1.default.createElement(exports.UserInfoContext.Provider, { value: context }, props.children);
};
exports.UserInfoProvider = UserInfoProvider;
const useUserInfo = () => (0, react_1.useContext)(exports.UserInfoContext);
exports.useUserInfo = useUserInfo;
//# sourceMappingURL=UserInfoContext.js.map